import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { AuthenticationService } from 'src/app/_services';
import { first } from 'rxjs/operators';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { LCSelector } from 'src/app/shared/models/LCSelector';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { TovpilCookieService } from 'src/app/utils/tovpil-cookie.service';
import { Constants } from 'src/app/shared/vo/Constants';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { ResponseFile } from 'src/app/shared/models/ResponseFile';

@Component({
  selector: 'app-lc-selector',
  templateUrl: './lc-selector.component.html',
  styleUrls: ['./lc-selector.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilCookieService]
})
export class LcSelectorComponent implements OnInit {

  /** PIPES */
  datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = {};

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** FORM */
  dataForm: FormGroup;
  dataParent: any;

  /** COMPONENT EXPORT */
  tableName: string;

  /** COMPONENT */
  coordinationCatalogList: LCSelector[] = [];
  selectedCoordinationCatalog: LCSelector[] = [];
  itemsNavigation?: MenuItem[] = [];
  homeNavigation: MenuItem;
  module: String;
  view: string;
  forLevelId: String;
  optionName: String;
  responseFile?: ResponseFile;

  /** ENDPOINTS */
  endPointLanguageByStoreId = "getListSpkLangByStoreId";
  endPointGetLstTreeChildStores = "getLstTreeChildStores";
  endPointGetStoreById = "getStoreByIdWithDescription";

  /** USER PREFERENCES */
  userPreferences: CookieTovpil = {};

  /**
   * This constructor function initializes various services and variables used in the component, and also
   * checks for authentication based on the token and device parameters passed in the URL.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user. It is likely used to show success or error messages during certain
   * operations.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
   * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
   * confirmation before performing certain actions.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API requests and handling responses.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
   * which is used to access the current route's information. It provides access to the route's
   * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
   * used to subscribe to the
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
   * the current user's information.
   * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
   * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
   * downloading files.
   * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
   * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
   * on data in the application.
   * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
   * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
   */
  constructor(private cookieService: TovpilCookieService,
    private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilCrudService: TovpilCrudService,
    private userPreferencesService: UserPreferencesService,
    private fb: FormBuilder,
    private router: Router,
    private filesService: TovpilFilesService,
    private translationService: TovpilLanguageService) {

    this.createDataForm();

    this.initConfigs();


    if (this.dataForm.get('token').value) {
      if (this.dataForm.get('device').value && this.dataForm.get('device').value == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
      this.dataForm.patchValue({
        currentUser: this.authenticationService.currentUserValue,
      });
    }
    const navigation = this.router.getCurrentNavigation();
    const dataParent = navigation.extras.state;
    if (dataParent) {
      this.module = dataParent.module;
      this.view = dataParent.view;
      this.forLevelId = dataParent.forLevelId;

    } else {
      this.route.queryParams
        .subscribe(
          params => {
            this.module = params.module;
            this.view = params.view;
            this.forLevelId = params.forLevelId;
          });
    }
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    this.dataForm.patchValue({
      currentUser: this.authenticationService.currentUserValue,
    });

    this.homeNavigation = { icon: 'pi pi-home', routerLink: '/treasurer/lcSelector' };
    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
            this.handleError('Autenticación', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
          }
        },
        error => {
          this.handleError('Autenticación', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    const securityControl = this.dataForm.get('security');
    if (!securityControl.value) {
      const tokenProfile = this.dataForm.get('currentUser').value?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      securityControl.patchValue(data);
    }
    this.getTranslatedLabels();
  }

  /**
   * The function `createDataForm` in TypeScript initializes a form group with various form controls and
   * default values, as well as setting some controls as disabled.
   */
  createDataForm() {
    this.dataForm = this.fb.group({
      // DEFAULT VALUES 
      data_language: new FormControl({ value: null }),
      data_languagesLst: [],
      data_user: new FormControl({ value: null, disabled: true }),

      // SECURITY
      token: [null],
      device: [null],
      storeId: [null],
      security: [null],
      currentUser: [null],
    });
  }

  /**
     * The function initializes form groups for configuration and data, and updates the configuration form
     * with query parameters from the route.
     */
  async initConfigs() {

    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation?.extras?.state || {};

    this.userPreferences = await this.userPreferencesService.getSantovTovpilCookie() || null;

    // SE ESTABLECE STORE ID INICIAL
    if (this.dataParent) {
      const { storeId } = this.dataParent;
      this.dataForm.patchValue({
        storeId: storeId
      });
    }

    // SE ESTABLECE PREFERENCIAS DE USUARIO
    if (this.userPreferences) {
      this.itemsNavigation = this.userPreferences?.preferences?.stores || [];
      // console.debug("LcSelector() Preferencias de usuario actual : " + JSON.stringify(this.userPreferences, null, 2));
    }


    this.getConfigs();
  }

  /**
   * The function `getConfigs()` logs the values of `configForm` and `dataForm` in a formatted JSON
   * string.
   */
  getConfigs() {
    const formConfig = {};
    // Iterar sobre las propiedades del formulario
    Object.keys(this.dataForm.controls).forEach(key => {
      const control = this.dataForm.get(key);
      const controlValue = control ? control.value : null;
      const controlDisabled = control ? control.disabled : null;

      formConfig[key] = {
        value: controlValue,
        disabled: controlDisabled
      };
    });

  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * `getLanguages`.
   */
  async getTranslatedLabels() {
    const security = this.dataForm.get('security').value || {};
    const language = security?.language || null;
    const region = security?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
      await this.getLanguages();
      await this.getOptionName();
    } catch (error) {
      console.error("Error en carga de etiquetas: An error occurred while getting translated labels:", error);
      //this.handleError('Coordinación', 'Se canceló carga ETIQUETAS, inténtelo más tarde');
    }
  }

  /**
   * The function `getLanguages` is an asynchronous function that fetches a list of languages and handles
   * any errors that occur during the process.
   */
  async getLanguages() {

    const security = this.dataForm.get('security').value || {};
    const language = security?.language || null;
    const storeId = this.dataForm.get('storeId').value || security?.storeId || "0000000002";

    try {
      const result = await this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, { language, storeId });

      if (result.success) {
        this.dataForm.patchValue({ data_languagesLst: result.data });

        if (language && storeId) {
          const data_languageValueId = this.dataForm.get('data_language').value?.valueId || null;
          const selectedLanguage = this.dataForm.get('data_languagesLst').value.find(o => o.valueId === language);

          this.dataForm.patchValue({
            data_language: data_languageValueId != null ? this.dataForm.get('data_language').value : selectedLanguage,
            data_user: security?.userId || null,
            storeId: storeId
          });

          await this.initLoadData();
        }
      } else {
        console.error("Error en carga de lenguajes: An error occurred while fetching languages:", result);
        //this.handleError('Coordinación', 'Se canceló carga LENGUAJES, inténtelo más tarde');
      }
    } catch (error) {
      console.error("Error en carga de lenguajes: An error occurred while fetching languages:", error);
      //this.handleError('Coordinación', 'Se canceló carga LENGUAJES, inténtelo más tarde');
    }
  }

  /**
   * The function is an asynchronous function that loads data from an API and displays a
   * message based on the validity of the form data.
   * @returns nothing.
   */
  async initLoadData() {
    if (!this.dataForm.valid) {
      this.handleError('Coordinación', 'Datos Inválidos, Por favor ingrese los datos solicitados!');
      return;
    }
    this.blocked = true;
    try {
      const security = this.dataForm.get('security').value || {};
      if (security.levelId == Constants.LOCAL_LEVELID) {
        this.listDependetGuideStores();
        //this.itemsNavigation.push({ label: " " + security?.selYear + " - " + security?.selPeriod ?? " ", id: security?.storeId ?? " " });
      } else {
        this.loadCoordinationCatalogs();
      }
    } catch (error) {
      this.blocked = false;
      console.error("Error en carga inicial" + error);
      //this.handleError('Coordinación', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
   * The function "loadCoordinationCatalogs" loads coordination catalogs from an API service and populates
   * various lists based on the received data.
   */
  loadCoordinationCatalogs() {
    const security = this.dataForm.get('security').value || {};

    if (this?.itemsNavigation?.length == 0 || !this?.itemsNavigation) {
      //this.itemsNavigation.push({ label: " " + security?.selYear + " - " + security?.selPeriod ?? " ", id: security?.storeId ?? " " });
    }
    this.lstCordinationCatalog();
  }

  /**
   * The function `lstCordinationCatalog` fetches coordination catalog data from an API, handles success
   * and error cases, and updates the `blocked` status accordingly.
   */
  async lstCordinationCatalog() {
    try {
      this.blocked = true;
      const security = this.dataForm.get('security').value || {};
      const _storeId = this.dataForm.get('storeId').value || security?.storeId || "0000000000";
      const storeId = this.itemsNavigation.length === 0 ? _storeId : this.itemsNavigation[this.itemsNavigation.length - 1].id;

      const responseStore = await this.getStoreById(storeId);
      this.coordinationCatalogList = [];
      if (responseStore != null) {
        this.coordinationCatalogList.push(
          {
            store: {
              storeId: responseStore?.storeId ?? '',
              addrId: responseStore?.addrId ?? '',
              addrIdAlt: responseStore?.addrIdAlt ?? '',
              descri: responseStore?.descri ?? '',
              shrName: responseStore?.shrName ?? '',
              status: responseStore?.status ?? '',
              type: responseStore?.type ?? '',
              typeDescrip: responseStore?.typeDescrip ?? '',
              isRedirect: false
            }
          }
        );

        const data = await this.apiService.getLstTreeChildStores(storeId, "Y");

        const dataFormated = data.map((store: any) => {
          return {
            ...store,
            isRedirect: true
          };
        });

        this.coordinationCatalogList.push(...dataFormated);
        this.blocked = false;

      }
    } catch (error) {
      this.blocked = false;
      console.error("Error en carga de catalogos: An error occurred while fetching coordination catalog data:", error);
      //this.handleError('Coordinación', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
   * The function `selectionCoordinationCatalog` processes a `StructureNodeVO` object and updates
   * `itemsNavigation` based on certain conditions.
   * @param {StructureNodeVO} coordinationCatalog - The `selectionCoordinationCatalog` function takes a
   * parameter `coordinationCatalog` of type `StructureNodeVO`. This function checks the `levelId` and
   * `storeId` properties of the `coordinationCatalog` object and performs different actions based on
   * their values. If the `levelId` is
   */
  selectionCoordinationCatalog(coordinationCatalog: LCSelector) {
    const storeId = coordinationCatalog?.store?.storeId;

    if (storeId !== 'L' && storeId !== null) {
      // Push the store details to itemsNavigation
      const storeDetails = {
        label: " " + coordinationCatalog?.store?.descri,
        id: storeId
      };
      this.itemsNavigation.push(storeDetails);
      // Call lstCordinationCatalog method
      this.lstCordinationCatalog();
    } else if (storeId !== 'L' && storeId === null) {
      // Handle error if storeId is null
      console.error("Error en carga de coordinacion seleccionada: An error occurred while redirect state to JSON:");
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
     * The function `updateModule` updates module information for navigation with additional data.
     * @param {LCSelector} coordinationCatalog - The `coordinationCatalog` parameter in the `updateModule`
     * function is of type `LCSelector`. It is used to extract the `store` property from the
     * `coordinationCatalog` object and assign it to `selStore` in the `navigationExtras` object.
     */
  async updateModule(coordinationCatalog: LCSelector) {
    try {
      const security = this.dataForm.get('security')?.value ?? {};

      const navigationExtras: NavigationExtras = {};

      //NO BORRAR LAS SIGUIENTES LINEAS:
      Constants.selStore = coordinationCatalog.store;

      // Update Cookie Preferences
      const stringItms = this.userPreferencesService.coordinationListToString(this.itemsNavigation);

      // ACTUALIZAMOS COOKIE EN BASE DE DATOS Y OBTENEMOS PARSE
      // console.debug("LcSelector() actualizará cookie e items de navegacio ...");
      // console.debug(this.itemsNavigation);
      // console.debug(stringItms);
      let selCord = coordinationCatalog?.store?.storeId ?? null;
      const responsePreferences = await this.userPreferencesService.manageCookie(
        security.userId ?? null,
        security.storeId ?? null,
        security.id ?? null,
        null,
        null,
        selCord,
        stringItms === null || stringItms === undefined ? selCord : stringItms,
        null,
        null,
        null
      );

      // Obtenemos preferencias parse
      const userDatabasePreferences = await this.userPreferencesService.getUserPreferences(
        security.userId ?? null,
        security.storeId ?? null,
        security.id ?? null,
        security.language ?? null,
        null,
        coordinationCatalog?.store?.storeId ?? null,
        stringItms,
        security.selYear ?? null,
        security.selPeriod ?? null,
        null);

      //SINO EXISTE PREFERENCIAS LAS CREA PARA MANEJAR LA COOKIE
      this.userPreferencesService.updateTovpilCookie(
        security?.levelId ?? null, // _levelId
        null, //_userId
        security?.storeId ?? null, //_storeId
        null, //_id
        null, //_language
        null, //_selCurrency
        coordinationCatalog?.store?.storeId ?? null, //_coordinationId
        stringItms ?? null, //_coordinationStack
        null, //_selYear
        null, //_selPeriod
        null, //_device
        { id: coordinationCatalog?.store?.storeId, label: coordinationCatalog?.store?.descri }, //_storeSelected
        { year: security.selYear ?? null, period: security.selPeriod ?? null, descrip: security.selYear ?? null + "" + security.selPeriod ?? null }, //_periodSelected
        userDatabasePreferences.stores ?? null         //_stores
      );

      // Navigate with Extras
      this.navigateWithExtras(navigationExtras);
    } catch (error) {
      console.error("Error redirigiendo");
      //this.handleError(`Redirecting to ${this.optionName}`, `An error occurred while redirecting to ${this.optionName}: ${error}`);
    }
  }


  /**
    * The function `navigateWithExtras` navigates to a specific route with additional navigation extras in
    * a TypeScript application.
    * @param {NavigationExtras} navigationExtras - The `navigationExtras` parameter in the
    * `navigateWithExtras` function is an object that can contain additional information for the
    * navigation process in Angular. It can include properties such as queryParams, fragment, state, and
    * more to customize the navigation behavior. These extras provide more flexibility and options when
    * navigating between different
    */
  navigateWithExtras(navigationExtras: NavigationExtras) {
    try {
      // console.log(this.module, this.view);
      this.router.navigate(['/', this.module, this.view], navigationExtras);
    } catch (error) {
      console.error("Error redirigiendo, navigation extras");
      this.handleError('Redirigir ' + this.optionName, 'Algo salió mal al redirigir a ' + this.optionName);
    }
  }

  /**
   * This TypeScript function asynchronously retrieves store data by ID using a CRUD service and handles
   * potential errors.
   * @param {string} _storeId - The `_storeId` parameter in the `getStoreById` function is a string
   * representing the unique identifier of the store that you want to retrieve information for.
   * @returns The `getStoreById` function returns the data fetched from the `tovpilCrudService` if the
   * operation is successful (`result.success` is true). If there is an error during the fetch operation,
   * it logs an error message and returns `null`.
   */
  async getStoreById(_storeId: string) {
    try {
      const result = await this.tovpilCrudService.fetch(this.endPointGetStoreById, { storeId: _storeId });
      if (!result.success) {
        throw new Error(`An error occurred while fetching store data`);
      }
      return result.data;
    } catch (error) {
      console.error(error);
      throw new Error("Failed to fetch store data.");
    }
  }

  /**
   * The function `goBack` pops an item from the `itemsNavigation` array if it has more than one item,
   * otherwise it closes the window, and then calls the `lstCordinationCatalog` function.
   */
  goBack() {
    if (this.itemsNavigation.length > 0) {
      this.itemsNavigation.pop();
    } else {
      window.close();
      return; // Detener la ejecución del método si se cierra la ventana
    }
    this.lstCordinationCatalog();
  }

  /**
   * The `exportExcel` function exports data from `coordinationCatalogList` to an Excel file.
   */
  async exportExcel(item) {
    const id_coord = item?.store?.storeId ?? null;
    this.blocked = true;
    if (this.module == 'secretary' && this.view == 'wrkshopMngComponent') {
      try {
        let data = await this.apiService.dwdWorkshopsXls(
          {
            "storeId": id_coord,
            "year": null,
            "period": null,
            "language": this.userPreferences.preferences.language ?? null
          }
        );
        this.responseFile = data;
        const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;
        const link = document.createElement("a");
        link.href = source;

        link.download = this.responseFile.nameFile
        link.click();
        this.blocked = false;

      } catch (error) {
        console.error("An error occurred while getting translated labels:", error);
        this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ` });
        this.blocked = false;
      }
    }
    else if (this.module == 'catalogs' && this.view == 'schoolfpg') {
      try {
        let data = await this.apiService.dwdSFPGSumaryXLS(
          {
            "storeId": id_coord,
            "year": null,
            "period": null,
            "language": this.userPreferences.preferences.language ?? null
          }
        );

        this.responseFile = data;
        const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;
        const link = document.createElement("a");
        link.href = source;

        link.download = this.responseFile.nameFile
        link.click();
        this.blocked = false;

      } catch (error) {
        console.error("An error occurred while getting translated labels:", error);
        this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ` });
        this.blocked = false;
      }
    }
    this.blocked = false;
  }

  /**
   * The exportPdf function exports data from the coordinationCatalogList array to a PDF file.
   */
  exportPdf() {
    try {
      if (this.coordinationCatalogList === null) {
        this.handleError('Coordinación', 'No existe información para procesar');
      } else if (this.coordinationCatalogList.length < 1) {
        this.handleError('Coordinación', 'Lista Vacia');
      } else {
        const filteredJSON = this.coordinationCatalogList.map((item) => ({
          "ID_COORD": item ? (item?.store?.storeId || 'S/N') : 'S/N',
          "NOMBRE": item ? (item?.store?.descri || 'S/N') : 'S/N',
          "TIPO": item ? (item?.store?.type || 'S/N') : 'S/N',
        }));

        const keysArray = filteredJSON.map((item) => Object.keys(item));
        const valuesArray = filteredJSON.map((item) => Object.values(item));

        this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listcordinationCatalog_');
      }
    } catch (error) {
      console.error("An error occurred while exporting to PDF:", error);
      this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
   * The `breadcrumbModel` function in TypeScript returns an array of objects with a `label` property
   * based on the items in the `itemsNavigation` array.
   * @returns An array of objects is being returned, where each object contains a `label` property
   * extracted from each item in the `itemsNavigation` array.
   */
  get breadcrumbModel() {
    return this.itemsNavigation.map(item => ({ label: item.label }));
  }

  /**
   * The handleError function handles errors by displaying a message and navigating back.
   * @param {string} summary - Summary is a brief description or title of the error that occurred. It
   * helps to provide a quick overview of what went wrong.
   * @param {string} detail - The `detail` parameter in the `handleError` function is a string that
   * provides additional information or details about the error that occurred. It is meant to give more
   * context or explanation about the error to help users understand what went wrong.
   */
  handleError(summary: string, detail: string) {
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'error',
      summary: summary,
      detail: detail,
      life: 5000
    });
  }

  /**
   * The function `getOptionName` retrieves the name of a specific option based on a given view and
   * concatenates it with a corresponding translation.
   */
  async getOptionName() {
    const viewOptions = {
      'fiiList': "CXC4) ",
      'schoolfpg': "SFPG) ",
      'locMatCtlLst': "CXC3) ",
      'wrkshopMngComponent': "WrkPla) ",
      "FISummary": "FI",
      "jrnHGuideReferIncExp": "CXC5)",
      "receivableLstH": "CXC2)",
      "FVIIEconReal" : "FVII)"
    };

    const labelsTranslated = {
      'fiiList': this.translations.lbl_die,
      'schoolfpg': this.translations.lbl_school_prep_guides,
      'locMatCtlLst': this.translations.lbl_material_payment_registry_Loc,
      'wrkshopMngComponent': this.translations.lbl_workshops_registry_planing_loc,
      "FISummary": "",
      "jrnHGuideReferIncExp": "FI Registro de Ofrendas",
      "receivableLstH": "Cuentas por Cobrar y Pagar (FV)",
      "FVIIEconReal" : "Realidad Economica"
    }

    if (this.view && viewOptions[this.view]) {
      this.optionName = viewOptions[this.view] + ' ' + labelsTranslated[this.view];
    } else {
      console.error("Vista no válida:", this.view);
      this.optionName = ""; // Opcional: Establecer vista default
    }
  }

  /**
   * The function `listDependetGuideStores` retrieves a list of dependent guide stores and populates the
   * `coordinationCatalogList` array with store information.
   */
  listDependetGuideStores() {


    this.coordinationCatalogList = [];
    const body = {
      guideId: this.userPreferences.preferences.guideId

    };
    let listStore = [];
    this.apiService.listDependetGuideStores(body).then(
      data => {
        listStore = data;
        if (listStore) {
          listStore.forEach((element) => {
            this.coordinationCatalogList.push(
              {
                store: {
                  storeId: element?.storeId ?? '',
                  addrId: element?.addrId ?? '',
                  addrIdAlt: element?.addrIdAlt ?? '',
                  descri: element?.descri ?? '',
                  shrName: element?.shrName ?? '',
                  status: element?.status ?? '',
                  type: element?.type ?? '',
                  typeDescrip: element?.typeDescrip ?? '',
                  isRedirect: true
                }
              }
            );
          });
        }
      }).finally(() => {
        setTimeout(() => {
          this.blocked = false;
        }, 1500);
      });;
  }
}
